import { render } from "./RecordBasicInfo.vue?vue&type=template&id=583fc12e&ts=true"
import script from "./RecordBasicInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecordBasicInfo.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/RecordBasicInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "583fc12e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('583fc12e', __exports__)) {
    console.log('reload')
    api.reload('583fc12e', __exports__)
  }
  
  module.hot.accept("./RecordBasicInfo.vue?vue&type=template&id=583fc12e&ts=true", () => {
    console.log('re-render')
    api.rerender('583fc12e', render)
  })

}


export default __exports__